module.exports = __webpack_public_path__ + "img/1.48e7ec71.png";